module.exports = __webpack_public_path__ + "static/media/slidebrowser.4a235a0a.png";